import { formatDate } from '@angular/common';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { RadioCheckBoxEnum } from '../../common/radio.checkbox.enums';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_429 implements Validator {

    public static id = 'CTRL_429';
    private message = 'error.ctr_429';


    public LOG: LogService = new LogService(CTRL_429);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_429.id + '_');


        if (rgs.length > 0) {
            for (let rg of rgs) {
                const ctrl = form.controls[rg];
                const attribueNameWithStepId = map.get(ctrl.value.rgCtrls.attribue);
                const dateAttributionNameWithStepId = map.get(ctrl.value.rgCtrls.dateAttribution);
                const dateAttributionCtrl = form.controls[dateAttributionNameWithStepId];
                const attribueCtrl = form.controls[attribueNameWithStepId];

                if (((attribueCtrl != undefined && dateAttributionCtrl != undefined)
                     && (attribueCtrl.value === RadioCheckBoxEnum.attribueUnique || attribueCtrl.value === RadioCheckBoxEnum.attribueLots)
                     && (dateAttributionCtrl.value === 'yyyy-MM-dd' || dateAttributionCtrl.value === ''))
                     || (dateAttributionCtrl != undefined && dateAttributionCtrl.value !== 'yyyy-MM-dd' && dateAttributionCtrl.value !== '' && dateAttributionCtrl.value > formatDate(new Date(), 'yyyy-MM-dd', 'en')))                                
                     {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}
